import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
type State = {
	isActive: boolean;
	lan?:string;
	calenderType?:string;
	TimeTableMonthFullYear: string[];
	HijraLocale: {
		isActive: boolean;
		lan?:string;
		calenderType?:string;
		customLan?:boolean;
	}
};
type Action = {
	updateISActive: ( isActive: State[ 'isActive' ] ) => void;
	updateTimeTableFullYear: ( TimeTableMonthFullYear: State[ 'TimeTableMonthFullYear' ] ) => void;
	updateHijraLocale: ( HijraLocale: State[ 'HijraLocale' ] ) => void;
	updateHijraLan: ( lan: State[ 'lan' ] ) => void;
	updateHijraCalenderType: ( calenderType: State[ 'calenderType' ] ) => void;
};
// Create your store, which includes both state and (optionally) actions
export const useTimeTableMonth = create< State & Action >()(
	devtools( ( set ) =>  ( {
		isActive: false,
		lan:"",
		calenderType:"",

		TimeTableMonthFullYear: [],

		HijraLocale: {
			isActive: false,
			lan:"",
			calenderType:"",
			customLan:false
		},

		updateISActive: ( isActive ) =>
			set( () => ( { isActive: isActive } ) ),
		
		updateTimeTableFullYear: ( TimeTableMonthFullYear ) =>
			set( () => ( { TimeTableMonthFullYear: TimeTableMonthFullYear } ) ),

		updateHijraLocale: ( HijraLocale ) =>
			set( () => ( { HijraLocale: HijraLocale } ) ),
		updateHijraLan: ( lan ) =>
			set( () => ( { lan: lan } ) ),
		updateHijraCalenderType: ( calenderType  ) =>
			set( () => ( { calenderType : calenderType  } ) ),

	} ),
	{name:"storeTimeTable"} )
);
